"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLoader = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("../SkeletonLoader/styled");
var styled_components_1 = require("styled-components");
var utilsOolib_1 = require("../../../utilsOolib");
/**
 * @component Renders a text loader component with customizable styling.
 *
 * - The props object containing the following properties:
 * @prop {React.CSSProperties} style: Additional CSS styles to apply to the text loader.
 * @return {ReactElement} The rendered text loader component.
 */
var TextLoader = function (_a) {
    var style = _a.style;
    var theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(styled_1.StyledSkeletonLoader, { style: __assign(__assign({ backgroundColor: (0, utilsOolib_1.getPrimaryColor10)(theme === null || theme === void 0 ? void 0 : theme.colors) }, (style || {})), { width: (style === null || style === void 0 ? void 0 : style.width) || "8rem", height: (style === null || style === void 0 ? void 0 : style.height) || "1.5rem" }) }));
};
exports.TextLoader = TextLoader;
